module.exports = __webpack_public_path__ + "static/img/icon_section_more_mo.f953df3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_section_more_mo.svg
// module id = Ze0S
// module chunks = 10